const filterListModal = {
  text: 'FILTROS',
  clear: 'limpar filtros'
};

export default filterListModal;
